import React from "react";
import styled from "styled-components";

export const H2 = styled.h2`
    /* MODAL TITLE */
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 700;
    color: var(--foreground);
`;
